import React from 'react';

const OrderCustomerPanel = ({ selectedCustomer, setSelectedCustomer, setFormData, setShowCustomerSelector, errors }) => {
  const handleChange = () => {
    setSelectedCustomer(null);
    setFormData(prev => ({ ...prev, klient_id: '' }));
    setShowCustomerSelector(true);
  };

  return (
    <div style={{ padding: '0.5rem', backgroundColor: 'var(--bg)', borderRadius: '4px', borderLeft: '3px solid var(--purple)' }}>
      <h4 style={{ margin: '0 0 0.4rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)' }}>
        Klient *
      </h4>

      {selectedCustomer ? (
        <div style={{ fontSize: '10px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
            <div>
              <div style={{ fontWeight: '600', marginBottom: '2px' }}>
                {selectedCustomer.nazwa_firmy ||
                  `${selectedCustomer.imie || ''} ${selectedCustomer.nazwisko || ''}`.trim()}
              </div>
              {selectedCustomer.email && (
                <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>Email: {selectedCustomer.email}</div>
              )}
              {(selectedCustomer.phone || selectedCustomer.telefon) && (
                <div style={{ color: 'var(--text-muted)', fontSize: '9px' }}>Tel: {selectedCustomer.phone || selectedCustomer.telefon}</div>
              )}
            </div>
            <button
              type="button"
              onClick={handleChange}
              style={{ padding: '4px 10px', fontSize: '11px', border: '1px solid var(--border)', backgroundColor: 'var(--card-bg)', cursor: 'pointer' }}
            >
              Zmien
            </button>
          </div>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setShowCustomerSelector(true)}
          style={{ width: '100%', padding: '6px 12px', fontSize: '12px', border: '1px solid var(--purple)', backgroundColor: 'var(--card-bg)', color: 'var(--purple)', cursor: 'pointer' }}
        >
          Wybierz klienta
        </button>
      )}

      {errors.klient_id && (
        <div style={{ color: 'var(--danger)', fontSize: '9px', marginTop: '4px' }}>{errors.klient_id}</div>
      )}
    </div>
  );
};

export default OrderCustomerPanel;
